import React from "react";
import {
    CardContent,
    Stack,
    Typography,
    Grid,
    List,
    ListItem,
    ListItemText, Avatar,
} from "@mui/material";
import {useSelector} from "react-redux";
import {DetailView} from "../../../../../Components";
import DomainIcon from '@mui/icons-material/Domain';
import {getIcon} from "../../../../../Setup/Utils/iconHelper";

export const Sidebar = () => {

    const item = useSelector((store) => store.departments.selected);
    
    // Get dynamic icon or fallback to DomainIcon
    const IconComponent = item?.icon ? getIcon(item.icon, 'outlined') : DomainIcon;

    return (
        <DetailView>
            <CardContent>
                <Grid container spacing={0}>
                    <Grid className={"upper-section"} item xs={12}>
                        <Grid container spacing={4}>
                            <Grid item xs={12}>
                                <Stack spacing={1} justifyContent={"center"} alignItems={"center"}>
                                    <Avatar 
                                        alt={item?.first_name} 
                                        variant="rounded" 
                                        sx={{ 
                                            width: 200, 
                                            height: 200, 
                                            borderRadius: '20%', 
                                            backgroundColor: 'primary.light', 
                                            border: '1px solid #01a3ff',
                                            boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.1)',
                                            '& svg': {
                                                color: 'primary.main'
                                            }
                                        }}>
                                        <IconComponent sx={{ fontSize: 40 }} />
                                    </Avatar>
                                    <Typography variant={"h2"} align={"center"}>{item?.department_name}</Typography>
                                </Stack>
                            </Grid>
                            <Grid item xs={12}>
                                <List className={"metrics"} direction={"column"}>
                                    <ListItem>
                                        <ListItemText primary={item?.users?.length} secondary={"Total Users"} />
                                    </ListItem>
                                </List>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </CardContent>
        </DetailView>
    );
};
